// Chain logos are served locally (public/assets/icons/chains/) instead of
// hotlinking raw.githubusercontent.com, which throttles/blocks direct
// production traffic (429s / timeouts) and made the ships' logos render as
// broken images.
export const supportedChains = [
  {
    name: "ethereum",
    ticker: "ETH",
    icon: "/assets/icons/chains/ethereum.png",
  },
  {
    name: "solana",
    ticker: "SOL",
    icon: "/assets/icons/chains/solana.png",
  },
  {
    name: "arbitrum",
    ticker: "ARB",
    icon: "/assets/icons/chains/arbitrum.png",
  },
  {
    name: "polygon",
    ticker: "MATIC",
    icon: "/assets/icons/chains/polygon.png",
  },
  {
    name: "avax",
    ticker: "AVAX",
    icon: "/assets/icons/chains/avax.png",
  },
  {
    name: "bsc",
    ticker: "BNB",
    icon: "/assets/icons/chains/bsc.png",
  },
  {
    name: "evmos",
    ticker: "EVMOS",
    icon: "/assets/icons/chains/evmos.png",
  },
  {
    name: "fantom",
    ticker: "FTM",
    icon: "/assets/icons/chains/fantom.png",
  },
  {
    name: "base",
    ticker: "BASE",
    icon: "/assets/icons/chains/base.png",
  },
  {
    name: "kava",
    ticker: "KAVA",
    icon: "/assets/icons/chains/kava.png",
  },
  {
    name: "optimism",
    ticker: "OP",
    icon: "/assets/icons/chains/optimism.png",
  },
  {
    name: "fuse",
    ticker: "FUSE",
    icon: "/assets/icons/chains/fuse.png",
  },
  {
    name: "gnosis",
    ticker: "GNO",
    icon: "/assets/icons/chains/gnosis.png",
  },
  {
    name: "klaytn",
    ticker: "KLAY",
    icon: "/assets/icons/chains/klaytn.png",
  },
  {
    name: "ethereum",
    ticker: "ETH",
    icon: "/assets/icons/chains/ethereum.png",
  },
  {
    name: "solana",
    ticker: "SOL",
    icon: "/assets/icons/chains/solana.png",
  },
  {
    name: "arbitrum",
    ticker: "ARB",
    icon: "/assets/icons/chains/arbitrum.png",
  },
  {
    name: "polygon",
    ticker: "MATIC",
    icon: "/assets/icons/chains/polygon.png",
  },
  {
    name: "avax",
    ticker: "AVAX",
    icon: "/assets/icons/chains/avax.png",
  },
  {
    name: "bsc",
    ticker: "BNB",
    icon: "/assets/icons/chains/bsc.png",
  },
  {
    name: "evmos",
    ticker: "EVMOS",
    icon: "/assets/icons/chains/evmos.png",
  },
  {
    name: "fantom",
    ticker: "FTM",
    icon: "/assets/icons/chains/fantom.png",
  },
  {
    name: "base",
    ticker: "BASE",
    icon: "/assets/icons/chains/base.png",
  },
  {
    name: "kava",
    ticker: "KAVA",
    icon: "/assets/icons/chains/kava.png",
  },
];
